import { h, Component, render } from 'preact';
import { matchPath } from 'react-router-dom';

class Ga extends Component {

	componentDidMount() {
		this.init(this.props.accountId, this.props.trackerName);
	}

	init = (accountId , trackerName = 'quikrPWATracker') => {

		const { qrum, location, match } = this.props;
		const config = typeof qrum === 'function' ? qrum(location, match) : qrum;
		// Initialize the command queue in case analytics.js hasn't loaded yet.
		window.ga = window.ga || ((...args) => (ga.q = ga.q || []).push(args));

		ga('create', 'UA-5568615-7', 'auto', 'quikrPWATracker');
		ga(`quikrPWATracker.set`, 'transport', 'beacon');

		if(accountId) {
			ga('create', accountId, 'auto', trackerName);
			ga(`${trackerName}.set`, 'transport', 'beacon');
		}
		import('quikr-rum').then((loaded) => {
			const quikrRUM = loaded.default;
			quikrRUM(config);
		});
		import('q-ga');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.accountId !== this.props.accountId || nextProps.trackerName !== this.props.trackerName ) {
			this.init(nextProps.accountId, this.props.trackerName);
		}
	}


	render() {
		return <span class="ga" />;
	}
}

export default Ga;



// WEBPACK FOOTER //
// ../q-components/components/analytics/index.js